import type { Task } from '@webapp/account/src/resources/tasks/task';

import type { States } from '../states';

import type { TasksState } from './state';

export const selectTasksRoot = ({ Tasks }: States): TasksState => Tasks;

export const selectTasks = (states: States): TasksState['tasks'] => {
    const t = selectTasksRoot(states);

    return t.tasks;
};

export const selectWaiting = (states: States): TasksState['waiting'] => {
    const t = selectTasksRoot(states);

    return t.waiting;
};

export const selectTasksByUuids =
    (uuids: Array<string>): ((s: States) => { [key in string]: Task }) =>
    (states: States): { [key in string]: Task } => {
        const t = selectTasks(states);

        const tasks: { [key in string]: Task } = {};

        for (const uuid of uuids) {
            tasks[uuid] = t[uuid];
        }
        return tasks;
    };
